module.exports = " <div class=alert-wrapper> <div v-for=\"alert in alerts\" v-show=alert.show class=alert transition=alert @click=hide(alert) role=alert> <strong>{{ messageTitle(alert) }}</strong> {{ alert.message }} </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/alerts.vue
// module id = 156
// module chunks = 2